import Colors from "@src/constants/Colors";
import styled from "styled-components";

export const NotificationCardWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: ${Colors.white};
  padding: 16px;
  margin: 0px 16px;
  border: 1px solid ${Colors.neutral_gray_300};
  border-radius: 8px;
`;

export const UnreadText = styled.div`
  font-family: "Ringside Regular-Bold";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${Colors.success_500};
`;

export const HeaderTitle = styled.div<{
  color: string;
}>`
  font-family: "Ringside Regular-Bold";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${(props) => props.color};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const ButtonText = styled.div`
  font-family: "Ringside Regular-Bold";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-transform: capitalize;
  color: ${Colors.primary};
  margin-left: 6px;
`;

export const Description = styled.div`
  font-family: "Ringside Regular-Book";
  font-style: normal;
  font-weight: 325;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: ${Colors.neutralblack};
`;
